import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Spacer } from 'foundations-components/components/Spacer';
import getSubscriptionTier from 'ui-forms-editor-automation-lib/utils/getSubscriptionTier';
import SUBSCRIPTION_TIERS from 'ui-forms-editor-automation-lib/constants/SUBSCRIPTION_TIERS';
import { getScopes } from 'FormsUI/selectors/Scope';
import { FreePopupFormDeprecation } from './FreePopupFormDeprecation';
import { PaidPopupFormDeprecation } from './PaidPopupFormDeprecation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PopupFormDeprecationContainer = () => {
  const scopes = useSelector(getScopes);
  const subscriptionTier = getSubscriptionTier(scopes);
  const warning = useMemo(() => {
    if (subscriptionTier === SUBSCRIPTION_TIERS.FREE) {
      return /*#__PURE__*/_jsx(FreePopupFormDeprecation, {});
    }
    return /*#__PURE__*/_jsx(PaidPopupFormDeprecation, {});
  }, [subscriptionTier]);
  return /*#__PURE__*/_jsxs("div", {
    children: [warning, /*#__PURE__*/_jsx(Spacer, {})]
  });
};